var _path, _line, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 115,
    viewBox: "0 0 115 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 3H100C106.627 3 112 8.37259 112 15V100C112 106.627 106.627 112 100 112H15C8.37258 112 3 106.627 3 100V15C3 8.37258 8.37259 3 15 3Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2,
    stroke: "#546E7A",
    strokeWidth: 6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 113,
    y1: 30,
    x2: 3,
    y2: 30,
    stroke: "#546E7A",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 55.9998C80 32 123.5 63.9998 70 103.5M84 79.9998C78.594 87.4006 74.5409 90.7924 65.5 95.4998M75 69.9998C63.9107 84.3946 56.7702 88.92 42.5 90.9998M59.5 70.9998L49.5 77.9998M72.5 56.9998C43.5 59.9998 28.5 74.4998 29.5 95.4998M27 55.9998L18.5 66.9998M21.5 98.9998C29.5126 107.745 34.4227 111.066 44.5 112M38.5 16.5H29M23 16.5H13.5",
    stroke: "#546E7A",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShap);
export default __webpack_public_path__ + "static/media/shap.7c8d6c40909deb6c5e89a2300f16ba52.svg";
export { ForwardRef as ReactComponent };